export default __webpack_public_path__ + "static/media/app-dev.5c03e4af.png";